import React from "react";

/**
 * Expects `menu` shaped like:
 * { week: [ { day: "Montag", items: ["Dish 1", "Dish 2", ...] }, ... ] }
 *
 * Renders a grid with days as columns and rows as dish slots.
 */
const DAY_ORDER = [
  "Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","Sonntag",
  "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday",
];

function normalizeMenu(menu) {
  if (!menu || !Array.isArray(menu.week)) return [];

  // sort by our preferred order if possible, otherwise keep given order
  const byDayIndex = (d) => {
    const i = DAY_ORDER.findIndex(x => x.toLowerCase() === d.toLowerCase());
    return i === -1 ? 999 : i;
  };

  const weekSorted = [...menu.week].sort(
    (a, b) => byDayIndex(a.day || "") - byDayIndex(b.day || "")
  );

  return weekSorted.map(d => ({
    day: d.day || "",
    items: Array.isArray(d.items) ? d.items : [],
  }));
}

export default function WeeklyMenuTable({ menu }) {
  const days = normalizeMenu(menu);
  const numCols = days.length || 0;
  const maxRows = days.reduce((m, d) => Math.max(m, d.items.length), 0);

  if (!numCols) {
    return (
      <div className="mt-8 text-sm text-gray-600">
        Kein Menü gefunden. Bitte lade einen Essensplan hoch.
      </div>
    );
  }

  return (
    <section className="mt-8">
      <h3 className="text-xl font-semibold text-gray-900 mb-3">
        Wochenübersicht
      </h3>

      {/* Header row */}
      <div
        className="grid rounded-t-lg overflow-hidden"
        style={{ gridTemplateColumns: `repeat(${numCols}, minmax(0,1fr))` }}
      >
        {days.map(({ day }, idx) => (
          <div
            key={`head-${idx}`}
            className="bg-[#76B3FF] text-white font-medium p-3 text-center border-r last:border-r-0"
          >
            {day}
          </div>
        ))}
      </div>

      {/* Body rows */}
      <div
        className="grid border border-t-0 rounded-b-lg overflow-hidden"
        style={{ gridTemplateColumns: `repeat(${numCols}, minmax(0,1fr))` }}
      >
        {Array.from({ length: maxRows }).map((_, rowIdx) =>
          days.map(({ items }, colIdx) => (
            <div
              key={`cell-${rowIdx}-${colIdx}`}
              className={`p-3 bg-white/70 border-r border-t last:border-r-0 ${
                rowIdx % 2 === 1 ? "bg-white" : ""
              }`}
            >
              <div className="text-sm text-gray-900">
                {items[rowIdx] ?? <span className="text-gray-400">—</span>}
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
}